import { defineStore } from 'pinia'
import {
  computed,
  reactive,
  Ref,
  ref,
} from 'vue'
import { CartButtonEnum } from 'www/vue_components/common/Analyses/enums'
import { BiomaterialCollection, CartAnalysesPrice } from 'www/vue_components/common/Analyses/types'
import dispatchCustomEventGlobally from 'www/utils/withDependences/dispatchCustomEventGlobally'
import usePartnerAnalysesStore
  from 'www/vue_components/common/Analyses/pages/PartnerAnalysesPage/stores/usePartnerAnalysesStore'

/**
 * Store для хранения информации о содержимом корзины
 * этот store используют несколько страниц, поэтому он в общей папке
 */

const useCartContentStore = defineStore('cartContent', () => {
  const ANALYSES_IN_CART_MAX_VALUE = 50
  const cartButtonType = ref(CartButtonEnum.trashbin)
  const biomaterialCollectionList: Ref<BiomaterialCollection[]> = ref([])
  const cartAnalysesPrice = reactive({
    full_analyses_price: 0,
    full_collection_services_price: 0,
    discount_price: 0,
    total_price: 0,
  })

  const partnerAnalysesStore = usePartnerAnalysesStore()

  const analysesInCart = computed(() => {
    if (!partnerAnalysesStore.isPartner(partnerAnalysesStore.partner)) {
      return []
    }

    return partnerAnalysesStore.partner.analyses.filter(analysis => analysis.is_in_cart)
  })

  const isAllAnalysesInCartUnavailable = computed(() => !analysesInCart.value.some(analysis => analysis.is_active))

  const totalAnalysesInCartCount = ref(0)

  const ifMaxAnalysesInCart = computed(() => totalAnalysesInCartCount.value >= ANALYSES_IN_CART_MAX_VALUE)

  function setTotalAnalysesInCartCount(count: number) {
    totalAnalysesInCartCount.value = count
  }

  function showMaxAnalysesLimitDialog() {
    dispatchCustomEventGlobally('dialog:open', {
      maxWidth: 304,
      noClickAnimation: true,
      title: 'Добавлено максимальное количество анализов',
      text: 'Если хотите добавить ещё, оформите заказ или удалите часть анализов',
      confirmText: 'Понятно',
    })
  }

  function setCartButtonType(newCartButtonType: CartButtonEnum) {
    cartButtonType.value = newCartButtonType
  }

  function setCartAnalysesPrice(newPrice: CartAnalysesPrice) {
    Object.assign(cartAnalysesPrice, newPrice)
  }

  function setBiomaterialCollection(newBiomaterialCollectionList: BiomaterialCollection[]) {
    const biomaterialCollectionListLength = biomaterialCollectionList.value.length

    biomaterialCollectionList.value.splice(0, biomaterialCollectionListLength, ...newBiomaterialCollectionList)
  }

  return {
    totalAnalysesInCartCount,
    setTotalAnalysesInCartCount,
    ANALYSES_IN_CART_MAX_VALUE,
    setBiomaterialCollection,
    setCartButtonType,
    setCartAnalysesPrice,
    biomaterialCollectionList,
    showMaxAnalysesLimitDialog,
    ifMaxAnalysesInCart,
    isAllAnalysesInCartUnavailable,
    cartButtonType,
    cartAnalysesPrice,
    analysesInCart,
  }
})

export default useCartContentStore
